import { BaseEntity } from '../base-entity';
import { ServicePrincipal } from './service-principal';
import { TemplateWorkspaceTargetSettings } from './template-workspace-target-settings';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
import { AuthzContextsActionMap } from '@mri-platform/resource-authz';
import { DataProperty, DataType, MetadataStore } from 'breeze-client';
import { validModuleCodeRegEx } from './shared-validators';
/// </code-import>

export interface TemplateWorkspace {
  id: string;
  authorizedServicePrincipalId?: string;
  backgroundColor: string;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  longLabel?: string;
  name: string;
  periodEnd: Date;
  periodStart: Date;
  productNameOrFamily: string;
  shortLabel: string;
  templatePbiWorkspaceName: string;
  tenantKey: string;
  authorizedServicePrincipal: ServicePrincipal;
  targetSettings: TemplateWorkspaceTargetSettings[];
}

/// <module-code> Place module level code between <module-code> tags
export interface TemplateWorkspace {
  moduleCodes?: string;
}

export enum TemplateType {
  Dev = 'Dev',
  Test = 'Test',
  Prod = 'Prod'
}

const typeFuncs = BaseEntity.makeStaticTypeFunctions<TemplateWorkspace>(EntityName.TemplateWorkspace);
/// </module-code>

export class TemplateWorkspace extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static propName = typeFuncs.propName;
  static authorization = AuthzContextsActionMap.crudFor(EntityName.TemplateWorkspace);
  static modulePlaceHolder = 'Content';

  public get modules() {
    return TemplateWorkspace.getModules(this.moduleCodes);
  }

  static register(metadataStore: MetadataStore) {
    const et = metadataStore.getAsEntityType(EntityName.TemplateWorkspace, false);
    et.addProperty(
      new DataProperty({
        name: TemplateWorkspace.propName('moduleCodes'),
        dataType: DataType.String,
        isNullable: true,
        isPartOfKey: false,
        defaultValue: null,
        validators: [validModuleCodeRegEx]
      })
    );
  }

  static getModules(moduleCodes: string | undefined) {
    return moduleCodes ? moduleCodes.split(',') : [TemplateWorkspace.modulePlaceHolder];
  }

  getModuleDtos() {
    return this.modules.map(module => ({
      productName: this.productNameOrFamily,
      templateWorkspaceName: this.templatePbiWorkspaceName,
      templateWorkspaceId: this.id,
      moduleName: module,
      moduleProductName: module !== TemplateWorkspace.modulePlaceHolder ? module : this.productNameOrFamily
    }));
  }
  /// </code>
  // Generated code. Do not place code below this line.
}
